import { Routes } from '@angular/router';
import { SetupMainComponent } from './layouts/main';
import { InternalLayoutComponent } from '../layouts';
import { AuthGuard } from '../../shared/auth/services';
import { SetupFiscalYearComponent } from './pages/setup-fiscal-year';
// import {YearReviewAnticipatedExpendituresComponent} from './pages/year-review-anticipated-expenditures';

export const setupRoutes: Routes = [
  {
    path: 'useraccount',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'setup',
        component: SetupMainComponent,
        children: [
          // { path: '', component: SetupFiscalYearComponent },
          { path: 'year', component: SetupFiscalYearComponent, title: 'Fiscal Year Setup' },
          // { path: 'anticipated-expenditures', component: YearReviewAnticipatedExpendituresComponent},
        ]
      },
    ]
  }
];
